import { render, staticRenderFns } from "./FormFieldRadio.vue?vue&type=template&id=6c48148c&scoped=true&"
import script from "./FormFieldRadio.vue?vue&type=script&lang=js&"
export * from "./FormFieldRadio.vue?vue&type=script&lang=js&"
import style0 from "./FormFieldRadio.vue?vue&type=style&index=0&id=6c48148c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c48148c",
  null
  
)

export default component.exports